'use strict';

import config from 'config';
import React, { Component } from 'react';

const { LABELS } = config;

class SystemMessage extends Component {
  constructor(props) {
    super(props);
  }

  getMessageByType(msg) {
    switch (msg.type) {
      case 'chat.memberjoin':
        return `${this.props.message.display_name} ${LABELS.member_join || 'has joined the chat'}`;
      case 'chat.memberleave':
        return `${this.props.message.display_name} ${LABELS.member_leave || 'has joined the chat'}`;
      case 'chat.rating':
        if (!this.props.message.new_rating) {
          return LABELS.rate_removed || 'You have removed the chat rating';
        }
        else {
          const rating = convertToSentenceCase(this.props.message.new_rating);
          return `${LABELS.rate_added || 'You have rated the chat service'} ${rating}`
        }
      case 'chat.info':
        return msg.info;
      case 'chat.error':
        return msg.error;
      default:
        return JSON.stringify(msg);
    }
  }

  getClassesByType(msg) {
    const baseClasses = 'system-msg';

    switch (msg.type) {
      case 'chat.error':
        return `${baseClasses} error`;
      default:
        return `${baseClasses} note`;
    }
  }

  render() {
    return (
      <div className="system-msg-container">
        <span className={this.getClassesByType(this.props.message)}>{this.getMessageByType(this.props.message)}</span>
      </div>
    );
  }
}

function convertToSentenceCase(str) {
  return str[0].toUpperCase() + str.slice(1);
}

SystemMessage.displayName = 'SystemMessage';
SystemMessage.propTypes = {
  message: React.PropTypes.object
};
SystemMessage.defaultProps = {
  message: {
    msg: ''
  }
};

export default SystemMessage;



// WEBPACK FOOTER //
// ./src/components/SystemMessage.js